export default __webpack_public_path__ + "static/educaTuRegionServicios-5a51309984da2921ba7165fc997e27e9.png";